import React from 'react';
import SectionSplitter from './SectionSplitter';

const PageHeader = ({ theme, title, subtitle, badge, children }) => {
  const isDark = theme === 'dark';

  return (
    <>
      <div
        style={{
          position: 'relative',
          paddingTop: '120px',
          paddingBottom: '0',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: isDark
              ? 'linear-gradient(160deg, rgba(220,38,38,0.07) 0%, transparent 60%)'
              : 'linear-gradient(160deg, rgba(220,38,38,0.05) 0%, transparent 60%)',
            pointerEvents: 'none',
          }}
        />

        <div
          style={{
            position: 'absolute',
            top: '-40px',
            right: '-80px',
            width: '400px',
            height: '400px',
            borderRadius: '50%',
            background: isDark
              ? 'radial-gradient(circle, rgba(220,38,38,0.12) 0%, transparent 65%)'
              : 'radial-gradient(circle, rgba(220,38,38,0.08) 0%, transparent 65%)',
            filter: 'blur(40px)',
            animation: 'breathPulseGlobal 6s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />

        <div className="max-w-7xl mx-auto px-4 pb-16 relative" style={{ zIndex: 1 }}>
          {badge && (
            <div
              className="inline-flex items-center gap-2 mb-6"
              style={{
                padding: '6px 16px',
                borderRadius: '999px',
                background: isDark
                  ? 'rgba(220,38,38,0.15)'
                  : 'rgba(220,38,38,0.08)',
                border: `1px solid ${isDark ? 'rgba(220,38,38,0.35)' : 'rgba(220,38,38,0.25)'}`,
                fontSize: '0.8rem',
                fontWeight: '600',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: isDark ? '#f87171' : '#dc2626',
              }}
            >
              <span
                style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: isDark ? '#f87171' : '#dc2626',
                  animation: 'breathPulseGlobal 2s ease-in-out infinite',
                  display: 'inline-block',
                  flexShrink: 0,
                }}
              />
              {badge}
            </div>
          )}

          <h1
            className={`font-bold leading-tight mb-6 ${isDark ? 'text-white' : 'text-gray-900'}`}
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            }}
          >
            <span
              style={{
                background: isDark
                  ? 'linear-gradient(135deg, #ffffff 0%, #f87171 100%)'
                  : 'linear-gradient(135deg, #111827 0%, #dc2626 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {title}
            </span>
          </h1>

          {subtitle && (
            <p
              className={`text-lg md:text-xl max-w-2xl leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`}
            >
              {subtitle}
            </p>
          )}

          {children && (
            <div className="mt-8">
              {children}
            </div>
          )}
        </div>
      </div>
      <SectionSplitter theme={theme} variant="wave" />
    </>
  );
};

export default PageHeader;
